import { render, staticRenderFns } from "./DocutaxRequests.vue?vue&type=template&id=f2d292ee&scoped=true&"
import script from "./DocutaxRequests.vue?vue&type=script&lang=js&"
export * from "./DocutaxRequests.vue?vue&type=script&lang=js&"
import style0 from "./DocutaxRequests.vue?vue&type=style&index=0&id=f2d292ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d292ee",
  null
  
)

export default component.exports